<template>
    <master-layout>

        <div class="breadcamb_box">
            <div>
                <h4 class="page-title m-b-0"><i class="ti-plug"></i> {{ $t('integrations') }} </h4>
                <ol class="breadcrumb">
                    <li><router-link :to="{ name: 'integrations.index' }">{{ $t('integrations') }}</router-link></li>
                    <li class="active">MailTrap</li>
                </ol>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <div class="card-box icon_integration">
            <div class="bar-widget m-b-15">
                <div class="table-box">
                    <div class="table-detail w_60">
                        <div class="iconbox">
                            <i class="ti-email"></i>
                        </div>
                    </div>
                    <div class="table-detail">
                        <label class="label label-default pull-right" v-if="isEnabled">{{ $t('activated') }}</label>
                        <label class="label label-danger pull-right" v-if="!isEnabled">{{ $t('inactive') }}</label>
                        <h5 class="m-t-0 m-b-5 d_inline_b">
                            <b>MailTrap</b>
                            <label class="label label-warning m-l-5 m-b-0 pull-right">Beta</label>
                        </h5>
                        <p class="m-b-5 text-muted">{{ $t('_integrations.description_mail-trap') }}</p>
                    </div>
                </div>
            </div>
            <div class="alert alert-danger t_center m-0" v-if="!isEnabled && !member.is_admin">{{ $t('_integrations.mail_trap.line_14') }}</div>
            <div v-if="member.is_admin">
                <ul>
                    <li>{{ $t('_integrations.mail_trap.line_01') }}</li>
                    <li>{{ $t('_integrations.mail_trap.line_02') }}</li>
                    <li>{{ $t('_integrations.mail_trap.line_03') }}</li>
                </ul>
                <hr>
                <p>{{ $t('_integrations.mail_trap.line_04') }}</p>
                <form @submit.prevent="store" novalidate>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-8">
                            <label class="input-group" :class="{ 'has-error': errors['domain'] }">
                                <input type="text" v-pml-focus v-model="domain" class="form-control" placeholder="Nome-da-empresa">
                                <span class="input-group-addon">@pml.email</span>
                            </label>
                            <span class="error" v-if="errors['domain']">{{ errors['domain'][0] }}</span>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 t_right">
                            <a href="#" @click.prevent="inactivate" class="btn btn-danger" v-if="isEnabled">{{ $t('inactivate') }}</a>
                            <button type="submit" class="btn btn-default">{{ $t('activate') }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="card-box">
            <h4 class="m-t-0">{{ $t('_integrations.mail_trap.line_05') }}</h4>
            <ul>
                <li v-html="$t('_integrations.mail_trap.line_06', [ tenant.domain ])"></li>
                <li v-html="$t('_integrations.mail_trap.line_07', [ tenant.domain ])"></li>
                <li v-html="$t('_integrations.mail_trap.line_08')"></li>
                <li v-html="$t('_integrations.mail_trap.line_09')"></li>
                <li v-html="$t('_integrations.mail_trap.line_10')"></li>
                <li v-html="$t('_integrations.mail_trap.line_11', [ tenant.domain ])"></li>
            </ul>

            <div class="alert alert_default m-0">
                <b>{{ $t('attention') }}!</b> {{ $t('_integrations.mail_trap.line_12') }}<br>
                {{ $t('_integrations.mail_trap.line_13') }}
            </div>
        </div>
    </master-layout>
</template>

<script>
    import { enableMailTrap, updateMailTrap } from 'services/integrations'
    import { isNil, cloneDeep, kebabCase } from 'lodash'
    import { mapGetters } from 'vuex'
    import { trans } from 'utils/helpers/translation'

    export default {
        name: 'MailTrap',
        data () {
            return {
                domain: null,
                errors: []
            }
        },
        metaInfo () {
            return {
                title: trans('integrations') + ' | Mailtrap'
            }
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant',
                'member': 'getMember',
                'company': 'getCompany'
            }),
            isEnabled () {
                return !isNil(this.tenant.domain)
            },
            suggestion () {
                return kebabCase(this.company.fancy_name)
            }
        },
        watch: {
            'tenant' (val, old) {
                if (val.domain !== old.domain)
                    this.domain = cloneDeep(val.domain)
            }
        },
        mounted () {
            if (!['premium_power_sales'].includes(this.tenant.stripePlan))
                this.$router.push({ name: 'error.404' })
            this.domain = cloneDeep(this.tenant.domain)
        },
        methods: {
            store () {
                enableMailTrap({ domain: this.domain })
                    .then(() => {
                        this.errors = []
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                    })
            },
            inactivate () {
                updateMailTrap({ domain: null })
                    .then(() => {
                        this.errors = []
                    })
                    .catch(error => {
                        this.errors = error.response.data.errors || []
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/providers/MailTrap.vue